const defaultPayments = [
    "Basic Pay",
    "Expenses",
    "Back Pay / Arrears",
    "Holiday Pay",
    "Holiday Hours",
    "Overtime",
    "Overtime Hours",
    "Unpaid Leave",
    "Unpaid Sick",
    "Bonus",
    "PILON",
    "Termination Payment",
    "Company Sick",
    "Company Maternity",
    "Advance"
];

export default defaultPayments;